export function convertLocalDateToUtcForLogs(localDate: moment.Moment): Date {
	return localDate.subtract(localDate.utcOffset(), 'minutes').toDate();
}
